import { lazy } from "react";
import { ElementDetails } from "@/lib/types";
import { Sizes } from "./constants";
import { PipelinesProps } from "./types";

export const details = {
  name: "GitlabPipelines",
  description: "List Project Pipelines",
  tags: ["Development"],
  category: "Gitlab",
  grid: Sizes,
  gridNames: {
    default: "Medium",
    large: "Large",
  },
  integrationsUsed: ["gitlab"],
  setup: lazy(() => import("./Setup").then(m => ({ default: m.Setup }))),
  defaultProps: {},
} as ElementDetails<PipelinesProps>;
